<template>
  <div>
    <!-- Content -->
    <div>
      <p class="mb-md">
        API credentials are required to access the {{ app.platform }} API.
        Enter a "Client Name" and click "Continue" below to add a new API client.
        Once the client is created, you’ll be able to view and copy the credentials.
      </p>
      <p class="has-text-warning mb-md">Note: You can retrieve these credentials only once, so make sure to store them securely.</p>
      <div>
        <b-field
          label="Client Name"
          :type="('name' in errors) ? 'is-danger' : ''"
          :message="('name' in errors) ? errors['name'][0] : ''">
          <b-input
            autocomplete="off"
            type="text"
            name="name"
            size="is-medium"
            v-model="name"
            :disabled="this.task.info.client"
          ></b-input>
        </b-field>
      </div>
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            size="is-medium"
            @click="goBack"
            expanded
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            size="is-medium"
            expanded
            :disabled="!ready || saving"
            :loading="saving"
            @click="goForward"
          >Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return this.context.route + '/users/'
    },
    json () {
      return {
        type: 'api',
        name: this.name
      }
    }
  },
  data () {
    return {
      saving: false,
      errors: {},
      name: null
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'onboarding.tasks', params: { connection: this.connection.id } })
    },
    async goForward () {
      if (this.task.info.client) {
        this.$emit('navigate', 'Confirmation')
      } else {
        await this.createClient()
      }
    },
    createClient () {
      this.saving = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.$emit('client:created', response.data)
        this.$buefy.toast.open({ type: 'is-success', message: 'Client created!' })
        this.updateTaskInfo(response.data)
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
      }).finally(() => {
        this.saving = false
      })
    },
    updateTaskInfo (client) {
      const taskBody = {
        info: {
          client: {
            id: client.id,
            name: client.name,
            status: client.status,
            type: client.type,
            client_id: client.client_id
          }
        }
      }
      const endpoint = this.context.route + '/assigned-tasks/' + this.$route.params.task + '/'
      return this.$http.patch(endpoint, taskBody).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Task Updated!' })
        this.$emit('navigate', 'Confirmation')
      })
    },
    completeTask () {
      const endpoint = this.context.route + '/assigned-tasks/' + this.$route.params.task + '/complete/'
      return this.$http.put(endpoint).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Task Completed!' })
        this.$router.push({ name: 'onboarding.tasks', params: { connection: this.connection.id } })
      })
    },
    ready () {
      return (this.name)
    }
  },
  mounted () {
    if (this.task.info) {
      this.name = this.task.info.client.name
    }
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    }
  }
}
</script>
